import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormReferenceTreeSelectAsyncProps } from './helper';

export const generate = (
  props?: Partial<IFormFieldSchema<IFormReferenceTreeSelectAsyncProps>>
): IFormFieldSchema<IFormReferenceTreeSelectAsyncProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.OBJECT,
    name: props?.name || id,
    title: props?.title || 'Reference Tree Select (Async)',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormReferenceTreeSelectAsync,
    'x-validator': [],
    'x-component-props': {
      modelIds: props?.['x-component-props']?.modelIds,
      transformer: props?.['x-component-props']?.transformer || '',
      childKey: props?.['x-component-props']?.childKey,
      parentKey: props?.['x-component-props']?.parentKey,
      hasChildrenKey: props?.['x-component-props']?.hasChildrenKey,
      selectableExpression: props?.['x-component-props']?.selectableExpression,
      leavesOnly: props?.['x-component-props']?.leavesOnly ?? false,
      placeholder: props?.['x-component-props']?.placeholder,
      allowClear: props?.['x-component-props']?.allowClear ?? true,
      mode: props?.['x-component-props']?.mode,
      size: props?.['x-component-props']?.size,
      disabled: props?.['x-component-props']?.disabled,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
